import { useEffect, useState } from 'react'
import BackOfficeAPIClient from '../clients/BackofficeAPIClient'
import { BrandOption } from '../types/BrandOption'
import { SiteOption } from '../types/SiteOption'
import { SiteBrand } from '../types/SiteBrand'

const backofficeApiClient = new BackOfficeAPIClient()

/**
 * Marques disponibles pour UN site donné (via la société - IDPlaque - à laquelle il appartient).
 * Contexte "site" : une seule requête, déclenchée uniquement quand un site est sélectionné.
 */
export function useSiteBrands(site: SiteOption | null): BrandOption[] {
    const [ brands, setBrands ] = useState<BrandOption[]>([])

    useEffect(() => {
        if (!site) {
            setBrands([])
            return
        }

        let cancelled = false

        backofficeApiClient.get<SiteBrand[]>(`/societes/${site.idPlaque}/marques`)
            .then(data => {
                if (cancelled) {
                    return
                }
                setBrands(
                    data
                        .map(association => ({ value: association.Make, label: association.Make }))
                        .sort((a, b) => a.label.localeCompare(b.label, 'fr')),
                )
            })
            .catch(error => {
                console.log(error)
                if (!cancelled) {
                    setBrands([])
                }
            })

        return () => {
            cancelled = true
        }
    }, [ site?.value ])

    return brands
}
